import React from 'react';
import _ from 'lodash';
import { Card } from 'semantic-ui-react';

const CARD_COUNT = 8;

// `dz-skeleton` (src/index.scss) provides the shimmer; these just size the bars.
const styles = {
  image: { height: '180px' },
  lineWide: { height: '10px', width: '70%', margin: '10px 0' },
  lineNarrow: { height: '10px', width: '45%', margin: '10px 0' },
  label: { height: '16px', width: '56px', marginTop: '8px' },
};

const StoriesSkeleton = () => (
  <Card.Group itemsPerRow={4} doubling stackable>
    { _.times(CARD_COUNT, i => (
      <Card key={`skeleton-${i}`}>
        <div className="dz-skeleton" style={styles.image} />
        <Card.Content>
          <div className="dz-skeleton" style={styles.lineWide} />
          <div className="dz-skeleton" style={styles.lineNarrow} />
          <div className="dz-skeleton" style={styles.label} />
        </Card.Content>
      </Card>
    )) }
  </Card.Group>
);

export default StoriesSkeleton;



/** WEBPACK FOOTER **
 ** ./src/components/all-stories-modal/StoriesSkeleton.js
 **/